import React from 'react'
import { MiniEntrada } from './MiniEntrada';
//import * as FaIcons from 'react-icons/fa';
import './Entradas.css';
import { Alcance1 } from './pages/Alcance1';
import { MedirTransporteTerrestre } from './components/MedirTransporteTerrestre';
import { MedirTransporteAereo } from './components/MedirTransporteAereo';
import { MedirTransporteMaritimo } from './components/MedirTransporteMaritimo';
import { MedirEnergiaElectrica } from './components/MedirEnergiaElectrica';
import { Reduccion } from './pages/Reduccion';
import { MedirReduccion } from './components/MedirReduccion';
import { useLocation, Link } from 'react-router-dom';
import { CategoriaLoading } from './CategoriaLoading';
import { year } from './Categorias';

function Entradas( props ) {
    console.log(props.user.email)
    const location = useLocation();
    console.log(year);
    if (location.state ===  null) {
        console.log('location sin state, redireccionando...')
        //window.location.href = '/categorias';
    }else{
        console.log('asignando subSel...')
        console.log(location.state);
        
    }
    const [titulo , setTitulo] = React.useState('Añade entradas por cada acción que genere carbono a la atmósfera');
    const {subSel} = location.state || {};
    console.log(subSel)
    const [sub, setSub] = React.useState([]);
    const [cantEntradas, setCantEntradas] = React.useState(0);
    const [cantReduccion, setCantidadReduccion] = React.useState(0);
    const [elemAnterior, setElemAnterior] = React.useState(null);

    React.useEffect(()=>{
        if ((subSel.length === 1) && (subSel[0].nombre === "Reducción huella de CO2")){
            setTitulo('Puedes cargar tus acciones de reducción de tu huella de carbono '
            +'si ya has realizado alguna previamente, en caso contrario finaliza tu medición.')
        }else{
            console.log(subSel);
        }
    },[])

    const cat_reduccion = [
        {
            id:8,
            nombre: "Reduccion",
            subcategorias: [
                {id: 9, nombre: "Reducción huella de CO2"},
            ] 
        }
    ];

    /* Cambia el color de la opción de minientradas seleccionado y hace el SET a
    la minientrada de reducción si ya ha ingresado más de una entrada en las subcategorias */
    const onClickMiniEntrada = async (subCat) => {
        console.log(JSON.stringify(subCat));
        if (subCat.id === 9) {
            setCantidadReduccion(cantReduccion + 1);
            setSub(subCat)
        }else{
            setCantEntradas(cantEntradas + 1);
            setSub(subCat); 
        }
        if (elemAnterior !== null){
            let elementAnterior = document.getElementById(elemAnterior);
            elemAnterior.style.background = 'transparent';//'transparent';
            elemAnterior.style.color = '#AFAFAF';
            if (elementAnterior) {console.log('elemente:: '+elementAnterior);elementAnterior.style.background = '';}
        }
        let elementNuevo = document.getElementById(subCat.id);
        elementNuevo.style.background = '#00C269';
        elementNuevo.style.color = '#FFFFFF';
        setElemAnterior(elementNuevo);
    }

    /* render el tipo de Medida seleccionado para ingresar los datos en el formulario respectivo */
    const renderSubcategoria = () => {
        if (sub.nombre === "Transporte terrestre") {
          return <MedirTransporteTerrestre user={props.user} sub={sub} year={year}></MedirTransporteTerrestre>
        }else if (sub.nombre === "Transporte aéreo") {
          return <MedirTransporteAereo user={props.user} sub={sub} year={year}></MedirTransporteAereo>
        }else if (sub.nombre === "Transporte marítima") {
          return <MedirTransporteMaritimo user={props.user} sub={sub} year={year}></MedirTransporteMaritimo>
        }
        else if (sub.nombre === "Consumo de energía eléctrica") {
          return <MedirEnergiaElectrica user={props.user} sub={sub} year={year}></MedirEnergiaElectrica>
        }
        else if (sub.nombre === "Reducción huella de CO2") {
            console.log('##### renderSubcategoria '+sub.nombre+' ## id: '+sub.id);
          return <MedirReduccion user={props.user} subsel={subSel}></MedirReduccion>
        }
    }

    if ( (subSel === null) || (subSel === undefined) || (subSel.length < 1)){
        return <CategoriaLoading />
    }else{        
    return (
        <div style={{ padding:'10% 25% 25% 10%'}}>
            <div>
                {renderSubcategoria()}
            </div>
            
            <div style={{width:'100%'}} className='login__container'>
                <h2 style={{ whiteSpace:'pre-line', textAlign:'center'}}>{titulo}</h2>
                { subSel.map(sub => (
                    <div className='seleccionCat'  key={sub.id}>
                        <label key={sub.nombre}>{sub.nombre}</label>
                        {
                            //sel.subcategorias.map(sub => (
                                <MiniEntrada onClick={() => onClickMiniEntrada(sub)} id={sub.id} icon='si' value={sub.nombre} key={sub.id} nombreSub={sub.nombre} sub={sub} state={ {sub} }>
                                </MiniEntrada>
                            //))
                        }
                    </div>
                    
                ))}
                {cantEntradas > 0 &&
                    <div className='seleccionCat' >
                        <label style={{color:'#8A8888'}}>Reducción</label>
                        <p style={{color:'lightgray'}}>Puedes cargar tus acciones de reducción de tu huella de carbono
                        si ya has realizado alguna previamente, en caso contrario finaliza tu medición.</p>
                        { 
                            cat_reduccion.map(cat1 => (
                                cat1.subcategorias.map(subR => (
                                    <MiniEntrada onClick={() => onClickMiniEntrada(subR)} id={subR.id} icon='no' value={subR.nombre} key={subR.id} nombreSub={subR.nombre} sub={subR} >
                                    
                                    </MiniEntrada>
                                ))
                            ))
                        }
                    </div>
                }
                <div style={{ textAlign:'end'}}>
                    { //cantReduccion > 0 &&
                        cantEntradas > 0 &&
                        <Link to='/medicion' className='boton__resultados' >VER RESULTADOS</Link>
                    }
                    
                </div>
            </div>
        </div>
    )}
}

export { Entradas };
